import React, { useState, useEffect  } from "react";
import { Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import DateRangeIcon from "@mui/icons-material/DateRange";
import './TimeCustomeCss.css'
import toast from "react-hot-toast";

const ReturnDate = ({ handleFormatted, selectedDate , tripType  , check}) => {
    const [startDate, setStartDate] = useState(null);


    useEffect(() => {
        if(selectedDate && selectedDate !== null){
            if(check){
                setStartDate(selectedDate);
                handleFormatted({ 'drop_date': selectedDate })
            }
        }
    }, [check , selectedDate]);

    useEffect(() => {
        let dbData = JSON.parse(localStorage.getItem('cab_listing')) || {};
        // let defaultDate = dbData.trip_type === tripType ? new Date(dbData.drop_date) ||  '' :'';
        let defaultDate;
        if(dbData.trip_type === tripType){
            defaultDate = dbData.drop_date ? new Date(dbData.drop_date) : '';
        }
        setStartDate(defaultDate);
        // handleFormatted({ 'drop_date': defaultDate })
    }, []);


    const DateHandler = (date) => {
        const selectedDateObj = new Date(date);
        const pickupDateObj = new Date(selectedDate);
    
        // Zero out the time for both dates
        selectedDateObj.setHours(0, 0, 0, 0);
        pickupDateObj.setHours(0, 0, 0, 0);
    
        if (!isNaN(selectedDateObj.getTime())) {
            if (selectedDateObj >= pickupDateObj) {
                setStartDate(selectedDateObj);
                handleFormatted({ drop_date: selectedDateObj });
            } else {
                toast.error('Return date should be after the pickup date');
                setStartDate(null);
                handleFormatted({ drop_date: null });
            }
        } else {
            toast.error('Invalid date input');
            setStartDate(new Date());
            handleFormatted({ drop_date: null });
        }
    };


    return (
        <Form.Group className="w15 position-relative"  controlId="">
            <Form.Label>Return</Form.Label>
            <DateRangeIcon />
            <DatePicker
                className="DateStyling"
                selected={startDate}
                value={startDate}
                placeholderText="Return Date"
                onChange={(date) => DateHandler(date)}
                minDate={ new Date() }
                dateFormat="dd/MM/yyyy"
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
            />
        </Form.Group>
    );
};

export default ReturnDate